import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <MediaSection />

        <AppSection />

        <FeaturesSection />

        <FaqSection />

        <ContactSection />

        <TopicsSection />

        <CarouselSection />

        <UpdatesSection />

        <IndexSection />

        <AboutSection />

        <CardsSection />

        <CommentsSection />

        <RankingSection />
      </main>

      <Footer />
    </div>
  );
}